import { configureStore } from '@reduxjs/toolkit';

import historyPageReducer from './slices/backHistorySlice';
import chatbotReducer from './slices/chatbotSlice';
import checklistStudentReducer from './slices/checklistStudentSlice';
import sliceFlagsReducer from './slices/flagsSlice';
import nameClassroomSlice from './slices/nameClassroomSlice';
import nameStudentsSlice from './slices/nameStudentsSlice';
import nameSubjectsReducer from './slices/nameSubjectsSlice';
import nameTeachersSlice from './slices/nameTeachersSlice';
import additionalStatisticsReducer from './slices/statistics/additionalStatisticsSlice';
import statisticsReducer from './slices/statistics/statisticsSlice';
import uploadFileReducer from './slices/uploadFileSlice';
import userTypeNameReducer from './slices/userSlice';

export const store = configureStore({
  reducer: {
    historyPage: historyPageReducer,
    subjectNames: nameSubjectsReducer,
    flagsNames: sliceFlagsReducer,
    userTypeName: userTypeNameReducer,
    chatbot: chatbotReducer,
    studentNames: nameStudentsSlice,
    teacherNames: nameTeachersSlice,
    classroomName: nameClassroomSlice,
    uploadFile: uploadFileReducer,
    checklistStudentIndex: checklistStudentReducer,
    statistics: statisticsReducer,
    additionalStatistics: additionalStatisticsReducer,
  },
});
